import { render, staticRenderFns } from "./TypeSignUp.vue?vue&type=template&id=687169e9"
import script from "./TypeSignUp.vue?vue&type=script&lang=js"
export * from "./TypeSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports